import { render, staticRenderFns } from "./SalonWorkers.vue?vue&type=template&id=e27ead42&scoped=true"
import script from "./SalonWorkers.vue?vue&type=script&lang=ts"
export * from "./SalonWorkers.vue?vue&type=script&lang=ts"
import style0 from "./SalonWorkers.vue?vue&type=style&index=0&id=e27ead42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27ead42",
  null
  
)

export default component.exports